import { store } from '@app/store';
import { AsyncReducers, staticReducers } from '@app/store/rootReducer';
import { StandBranch, StandBuild } from '@pages/stands/types';
import { NavigateOptions } from 'react-router-dom';

export type UnknownObject = { [key: string]: unknown };

export type Pagination = {
    pageIndex: number;
    pageSize: number;
};

export type SortingDirection = 'asc' | 'desc' | null;

export type Sorting = { id: string; desc: SortingDirection }[];

export type TableSorting = Array<{
    id: string;
    desc: boolean;
}>;

export type ColumnFilter = { id: string; value: string };

export type ColumnFilters = ColumnFilter[];

export type StaticReducersState = {
    [K in keyof typeof staticReducers]: ReturnType<(typeof staticReducers)[K]>;
};

export type RootState = StaticReducersState & AsyncReducers;

export type AppDispatch = typeof store.dispatch;

export type PaginatedList<T = unknown> = {
    items: T[];
    count: number;
};

export enum RequestStatusEnum {
    NotRequested = 'NOT_REQUESTED',
    Loading = 'LOADING',
    Success = 'SUCCESS',
    Error = 'ERROR',
}

export enum AppLanguage {
    RU = 'ru',
    ENG = 'en',
}

export enum AccessEnum {
    Private = 'Private',
    Locked = 'Locked',
    Public = 'Public',
}

export type SetUrlParamsFunction = (newParams: UnknownObject, options?: NavigateOptions) => void;

export type DeployFiltersError = 'branch' | 'build' | 'architecture' | null;

export type SelectedFilter = {
    branch: StandBranch;
    build: StandBuild;
    build_details: { architecture: 'x86' | 'arm' | ''; types?: string[] };
    is_public: boolean;
};

export type StepLabelType = string;
export type StepIndexType = number;
